var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32px",
    height: "32px",
    viewBox: "0 0 126.000000 126.000000",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,126.000000) scale(0.100000,-0.100000)",
    fill: "#a8504d",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174 1187 c-87 -99 -153 -236 -154 -314 0 -17 -4 -35 -10 -38 -13 -8 -13 -132 0 -140 5 -3 10 -18 10 -33 0 -73 71 -221 140 -293 41 -43 63 -47 68 -10 2 14 -9 36 -32 61 -109 121 -152 320 -106 487 22 82 45 126 101 199 45 59 51 94 17 94 -13 -1 -28 -6 -34 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 1178 c0 -11 18 -44 39 -72 56 -73 79 -117 101 -199 22 -80 26 -170 9 -249 -16 -75 -70 -188 -113 -236 -25 -27 -36 -49 -34 -63 5 -37 27 -33 68 10 69 72 140 220 140 293 0 15 5 30 10 33 6 3 10 35 10 70 0 35 -4 67 -10 70 -5 3 -10 20 -10 37 0 68 -72 221 -138 296 -35 38 -72 43 -72 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 1008 c-58 -65 -100 -185 -91 -260 11 -94 28 -138 76 -206 31 -42 57 -52 79 -30 8 8 6 19 -10 42 -12 17 -25 33 -28 36 -3 3 -16 26 -28 52 -45 98 -25 238 47 325 25 30 28 39 18 54 -17 27 -30 24 -63 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 1021 c-10 -15 -7 -24 16 -52 50 -63 71 -122 71 -204 0 -56 -5 -87 -22 -123 -12 -26 -25 -49 -28 -52 -3 -3 -16 -19 -28 -36 -16 -23 -18 -34 -10 -42 22 -22 48 -12 79 30 48 68 65 112 76 206 9 75 -33 195 -91 260 -33 37 -46 40 -63 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 903 c-36 -7 -89 -61 -96 -100 -10 -55 4 -104 43 -140 31 -30 41 -33 93 -33 52 0 62 3 93 33 109 102 16 268 -133 240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 298 l3 -233 25 0 25 0 3 233 2 232 -30 0 -30 0 2 -232z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkError);
export default __webpack_public_path__ + "static/media/networkError.105fcce504fbef888dbbd933cef0691c.svg";
export { ForwardRef as ReactComponent };